import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_decor-and-style/artifacts/89wv37zw_LOGO.png";

const CATEGORIES = [
  { label: 'Fashion', value: 'fashion' },
  { label: 'Lifestyle', value: 'lifestyle' },
  { label: 'Home Decor', value: 'home-decor' },
  { label: 'Other', value: 'other' },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A1128] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="Style and Space" className="w-12 h-12 rounded-full object-cover" />
              <span className="font-['Playfair_Display'] text-2xl font-bold">Style & Space</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Your curated destination for fashion inspiration, lifestyle tips, and home decor ideas. Discover the best products handpicked for your style.
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="overline text-white/40 mb-6">Categories</h4>
            <div className="space-y-3">
              {CATEGORIES.map(cat => (
                <Link
                  key={cat.value}
                  to={`/articles/${cat.value}`}
                  className="block text-white/70 hover:text-white transition-colors text-sm"
                  data-testid={`footer-category-${cat.value}`}
                >
                  {cat.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Connect */}
          <div>
            <h4 className="overline text-white/40 mb-6">Connect</h4>
            <div className="space-y-3">
              <a
                href="https://in.pinterest.com/styleandspace4u/"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-white/70 hover:text-white transition-colors text-sm"
                data-testid="footer-pinterest"
              >
                Pinterest
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-white/40 text-xs tracking-wider">&copy; {new Date().getFullYear()} Style & Space. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
